export enum EmployerType {
  Current = 1,
  Previous = 2,
  Additional = 3,
}

export class EmployerTypeIds {
  public static get Current(): number {
    return EmployerType.Current;
  }
  public static get Additional(): number {
    return EmployerType.Additional;
  }
  public static get Previous(): number {
    return EmployerType.Previous;
  }
}
export class EmployerRecord {
  id = 0;
  employerTypeId: number | null = null;
  employerName?: string | null = "";

  constructor(initialValues?: Partial<EmployerRecord>) {
    if (initialValues) {
      Object.assign(this, initialValues);
    }
  }
}
